<template>
  <v-container fluid>
    <loading v-if="loading"></loading>
    <customer-order v-else></customer-order>
    <info-alert
        v-model="infoAlertState"
        :text="infoAlertText"
        :alert-type="alertOrderType"
        :alert-font-size="alertOrderFontSize"
    />
  </v-container>
</template>

<script>
import CustomerOrder from "@/modules/delivery/components-core/customer/CustomerOrder/CustomerOrder.vue";
import {CUSTOMER} from "@/modules/delivery/constants/OrderOrigin";
import {Loading} from "@dracul/common-frontend"
import InfoAlert from "@/modules/base/components/InfoAlert";

export default {
  name: "CustomerOrderPage",
  components: {InfoAlert, CustomerOrder, Loading},
  created() {
    this.$nextTick(() => this.init())
  },
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    orderHasIdentifier() {
      return this.$store.getters.orderSystem.order.identifier
    },
    orderIsComplete() {
      return ["DELIVERED", "CANCELED"].includes(this.$store.getters.orderState)
    },
    hasOrder() {
      return this.$store.getters.hasOrder;
    },
    hasOrderIdentifier() {
      return !!this.$store.getters.orderIdentifier
    },
    orderIdentifier() {
      return this.$store.getters.orderIdentifier
    },
    orderState(){
      return this.$store.getters.orderState
    },
    //INFO ALERT
    infoAlertState: {
      get() {
        return this.$store.getters.getSettingValue('alertOrderBoolean') && !this.$store.getters.getCurrentOrderIdentifier || false
      },
      set(val) {
        this.$store.commit('setSetting', {key: 'alertOrderBoolean'}, val)
      }
    },
    infoAlertText() {
      return this.$store.getters.getSettingValue('alertOrderText')
    },
    alertOrderType() {
      return this.$store.getters.getSettingValue('alertOrderType')
    },
    alertOrderFontSize() {
      return this.$store.getters.getSettingValue('alertOrderFontSize')
    },
  },
  methods: {
    async init() {
      this.loading = true
        if (this.hasOrder) {
          if(this.hasOrderIdentifier){

            await this.$store.dispatch('findOrderByIdentifier', this.orderIdentifier)

            if (this.orderIsComplete) {
              console.log("Order is complete. Clear and Init new Order.")
              this.$store.commit("clearOrder")
              this.$store.dispatch("initOrder", {origin: CUSTOMER})
            } else {
              console.log("Order is not complete. Redirect to follow order page.")
              return this.redirectToFollowOrder()
            }

          }
          this.$store.commit("setOrigin", CUSTOMER)
        } else {
          this.setupNewOrder()
        }

        this.$store.dispatch("setupOrderSystem")
        this.$store.dispatch("fetchDefaultBranch")



      this.loading = false

    },
    async setupNewOrder() {
      this.$store.commit("clearOrder")
      await this.$store.dispatch("initOrder", {origin: CUSTOMER})
      this.$store.commit("orderContact", this.$store.getters.lastContact)
    },
    redirectToFollowOrder() {
      this.$router.push({
        name: 'CustomerOrderViewPage',
        params: {identifier: this.$store.getters.orderIdentifier}
      })
    }
  }
}
</script>

<style scoped>

</style>
